export const RESOURCES = {
    automated_rules: 'automated_rules',
  };